import React from 'react';
import PropTypes from 'prop-types';
import Grid from '../components/Grid.jsx';
import FormikRadioGroup from '../formik-fields/FormikRadioGroup.jsx';

const GridFormikRadioGroup = ({ gridProps, ...props }) => {
  return (
    <Grid item {...gridProps}>
      <FormikRadioGroup {...props} />
    </Grid>
  );
};

GridFormikRadioGroup.propTypes = {
  disabled: PropTypes.bool,
  value: PropTypes.oneOfType([ PropTypes.string, PropTypes.number, PropTypes.array ]),
  multiple: PropTypes.bool,
  name: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired,
  'data-testid': PropTypes.string,
  label: PropTypes.string,
  labelClass: PropTypes.string,
  labelPlacement: PropTypes.string,
  gridProps: PropTypes.object.isRequired,
  alignment: PropTypes.oneOf(['horizontal', 'vertical']),
};

export default GridFormikRadioGroup;
